<div class="content-container">
    <div class="content-area">
        <clr-tabs>
            <clr-tab>
                <button clrTabLink>Избор на технологии</button>
                <ng-template [(clrIfActive)]="tehnologieChoose">
                    <clr-tab-content>
                        <div class="clr-row">
                            <div class="clr-col">
                                <div class="card">
                                    <div class="card-header">
                                        Филтър за технологии
                                    </div>
                                    <div class="card-block">
                                        <form clrForm [formGroup]="filterForm">
                                            <clr-input-container>
                                                <label>Наименование</label>
                                                <input clrInput formControlName="Name" autocomplete="off" />
                                                <clr-control-error *clrIfError="'required'">Грешка</clr-control-error>
                                            </clr-input-container>

                                            <clr-datalist-container>
                                                <label>Склад</label>
                                                <input clrDatalistInput formControlName="Store" autocomplete="off" />
                                                <datalist>
                                                    <option *ngFor="let item of storeOptions" [value]="item.Name.BG">
                                                    </option>
                                                </datalist>
                                            </clr-datalist-container>

                                            <!-- <clr-datalist-container>
                                              <label>Продуктова група</label>
                                              <input clrDatalistInput formControlName="ProductGroup" autocomplete="off"/>
                                              <datalist>
                                                  <option *ngFor="let item of groupOptions" [value]="item.Name.BG"></option>
                                              </datalist>
                                          </clr-datalist-container> -->

                                            <clr-date-container>
                                                <label>От дата</label>
                                                <input type="date" clrDate formControlName="ReleaseDate"
                                                    autocomplete="off">
                                            </clr-date-container>
                                            <clr-date-container>
                                                <label>До дата</label>
                                                <input type="date" clrDate formControlName="ExpiryDate"
                                                    autocomplete="off">
                                            </clr-date-container>
                                            <!-- <clr-input-container>
                                                  <label>Склад</label>
                                                  <select clrInput formControlName="Store" >
                                                    <option *ngFor="let item of storeOptions" [value]="item">{{item.name}}</option>
                                                  </select>
                                          </clr-input-container> -->

                                            <clr-input-container>
                                                <label>Брой резултати</label>
                                                <input clrInput formControlName="take" autocomplete="off" />
                                                <clr-control-error *clrIfError="'required'">Само цели числа
                                                </clr-control-error>
                                                <clr-control-error *clrIfError="'pattern'">Само цели числа
                                                </clr-control-error>
                                                <clr-control-error *clrIfError="'min'">Само цели числа по-големи от 1
                                                </clr-control-error>
                                            </clr-input-container>

                                            <clr-combobox-container>
                                                <label>Съставка</label>
                                                <clr-combobox formControlName="material" autocomplete="off"
                                                (clrInputChange)="fetchProducts($event)"
                                                (clrOpenChange)="$event ? fetchProducts() : null"
                                                clrMulti="false"
                                                [clrLoading]="loadingProducts"
                                                >
                                                  <ng-container *clrOptionSelected="let prod">
                                                    {{prod?.PartNumber}} / {{prod?.Name?.BG}}
                                                  </ng-container>
                                                  <clr-options>
                                                    <clr-option *ngFor="let prod of products" [clrValue]="prod">
                                                        {{prod?.PartNumber}} / {{prod?.Name?.BG}}
                                                    </clr-option>
                                                  </clr-options>
                                                </clr-combobox>
                                              </clr-combobox-container>
                                        </form>
                                    </div>
                                    <div class="card-footer">
                                        <button class="btn btn-primary" type="submit"
                                            (click)="loadRecepies()">Филтрирай</button>
                                        <button class="btn" type="button" (click)="resetForm()">Изчисти</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="clr-row">
                            <div class="clr-col">
                                <div class="card">
                                    <div class="card-header">
                                        Технологии отговарящи на филтъра
                                    </div>
                                    <div class="card-block">
                                        <recepie-grid [recipes]="filteredRecepies"
                                            [(selectedFiltered)]="filteredSelected"></recepie-grid>
                                    </div>
                                    <div class="card-footer">
                                        <button class="btn btn-primary" (click)="addRecipes()">Добави към
                                            избани</button>
                                        <button class="btn" (click)="removeFiltered()">Премахни</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="clr-row">
                            <div class="clr-col">
                                <div class="card">
                                    <div class="card-header">
                                        Избрани технологии
                                    </div>
                                    <div class="card-block">
                                        <recepie-grid [recipes]="recepiesToProcess"
                                            [(selectedFiltered)]="recepiesToProcessSelected"></recepie-grid>
                                    </div>
                                    <div class="card-footer">
                                        <button class="btn" (click)="removeRecepiesToProcess()">Премахни</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </clr-tab-content>
                </ng-template>
            </clr-tab>

            <clr-tab>
                <button clrTabLink>Замени</button>
                <ng-template [(clrIfActive)]="replaceActive">
                    <clr-tab-content>
                        <div class="clr-row">
                            <div class="clr-col">
                                <div class="card">
                                    <div class="card-block">
                                        <substitude-define (saveFunction)="saveSubstitude($event)"
                                            [recipes]="recepiesToProcess" [substitudes]="substitudesArray">
                                        </substitude-define>
                                        <!-- <substitude-grid [substitudes]="substitudesArray"></substitude-grid> -->
                                    </div>
                                    <!-- <div class="card-footer">
                                      <button class="btn btn-primary" type="submit" (click)="loadRecepies()">Филтрирай</button>
                                      <button class="btn" type="button" (click)="resetForm()">Изчисти</button>
                                  </div> -->
                                </div>
                            </div>
                        </div>
                    </clr-tab-content>
                </ng-template>
            </clr-tab>

            <clr-tab>
                <button clrTabLink>Резултат</button>
                <ng-template [(clrIfActive)]="resultActive">
                    <clr-tab-content>
                        <result-tree [recepiesToProcess]="recepiesToProcess" [substitudes]="substitudesArray">
                        </result-tree>
                    </clr-tab-content>
                </ng-template>
            </clr-tab>

            <clr-tab>
                <button clrTabLink>Настройки</button>
                <ng-template [(clrIfActive)]="settingsActive">
                    <clr-tab-content>
                        <div class="clr-row">
                            <div class="clr-col">
                                <div class="card">
                                    <div class="card-header">
                                        Настройки
                                    </div>
                                    <div class="card-block">
                                        <form clrForm [formGroup]="settingsForm">
                                            <clr-radio-container clrInline>
                                                <label>Режим</label>
                                                <clr-radio-wrapper>
                                                    <input type="radio" value="copy" clrRadio formControlName="new" />
                                                    <label>Копирай</label>
                                                </clr-radio-wrapper>
                                                <clr-radio-wrapper>
                                                    <input type="radio" value="new" clrRadio formControlName="new" />
                                                    <label>Създай нова</label>
                                                </clr-radio-wrapper>
                                                <clr-radio-wrapper>
                                                    <input type="radio" value="edit" clrRadio formControlName="new" />
                                                    <label>Редактирай съществуващата</label>
                                                </clr-radio-wrapper>
                                                <clr-control-helper>При избиране на "Създай нова" посочете дата на
                                                    валидност на старата. При Копиране не взима предвид замените
                                                </clr-control-helper>
                                            </clr-radio-container>

                                            <clr-toggle-container>
                                                <label>Стандартна себестойност</label>
                                                <clr-toggle-wrapper>
                                                  <input type="checkbox" clrToggle value="true" formControlName="SaveStandartCost" />
                                                  <label>Запази стандартна себестойност</label>
                                                </clr-toggle-wrapper>
                                                <clr-control-helper>Запазва стандартна себестойност на продукта след промяна на технологията
                                                </clr-control-helper>
                                              </clr-toggle-container>

                                            <clr-datalist-container>
                                                <label>Склад</label>
                                                <input clrDatalistInput formControlName="Store" autocomplete="off" />
                                                <datalist>
                                                    <option *ngFor="let item of storeOptions" [value]="item.Name.BG">
                                                    </option>
                                                </datalist>
                                            </clr-datalist-container>

                                            <clr-date-container>
                                                <label>От дата</label>
                                                <input type="date" clrDate formControlName="ReleaseDate"
                                                    autocomplete="off">
                                            </clr-date-container>

                                            <clr-date-container>
                                                <label>До дата</label>
                                                <input type="date" clrDate formControlName="ExpiryDate"
                                                    autocomplete="off">
                                            </clr-date-container>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </clr-tab-content>
                </ng-template>
            </clr-tab>

            <clr-tab>
                <button clrTabLink>Обработка</button>
                <ng-template [(clrIfActive)]="infrastructureActive">
                    <clr-tab-content>
                        <div class="clr-row">
                            <div class="clr-col">
                                <div class="card">
                                    <div class="card-header">
                                        Стартирай обработ
                                    </div>
                                    <div class="card-block">
                                        <button [disabled]="disableProcessButton" class="btn btn-outline"
                                            (click)="startProcessing()">Стартирай обработката</button>
                                    </div>
                                    <div class="card-block">
                                        <log-monitor [logStream]="executionLog | async" theme="dark"
                                            title="Лог на обработката" [animated]="true" [icons]="true"></log-monitor>
                                    </div>
                                    <div class="card-footer">
                                        <!-- <app-progress></app-progress> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </clr-tab-content>
                </ng-template>
            </clr-tab>
        </clr-tabs>
    </div>
</div>